import React from 'react'
import HomePage from './HomePage'
import ServicesPage from './ServicesPage'
import ServiceDetailPage from './ServiceDetailPage'
import AboutPage from './AboutPage'
import ProcessPage from './ProcessPage'
import PricingPage from './PricingPage'
import ContactPage from './ContactPage'
import LegalPage from './LegalPage'
import { servicePages } from '../data/siteData'

export default function RoutePage(){const path=window.location.pathname.replace(/\/$/,'')||'/';if(path==='/services')return <ServicesPage/>;if(path==='/about')return <AboutPage/>;if(path==='/process')return <ProcessPage/>;if(path==='/pricing')return <PricingPage/>;if(path==='/contact')return <ContactPage/>;if(path==='/privacy'||path==='/terms')return <LegalPage type={path.slice(1)}/>;if(path.startsWith('/services/')){const service=servicePages.find(s=>s.slug===path.split('/')[2]);if(service)return <ServiceDetailPage service={service}/>};return <HomePage/>}
